import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { C_ON_SURFACE_VARIANT, C_OUTLINE_VARIANT, C_PRIMARY } from "~/common/components/icon/Colors";
import { TableCell } from "~/common/components/Table/TableElements";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";
import { PopperTooltip } from "~/common/components/Tooltip";

export const TableContainer = styled("div")({
  width: "100%",
  overflowX: "auto",
  whiteSpace: "nowrap",
});

export const TableTitle = styled('p')({
  ...getFontStyle(FontSize.HeadlineMedium),
  fontWeight: "bold",
  marginBottom: "16px",
});

//TODO : we're blocked by table.less and it's breaking so added !important for border and padding style
export const StyledColumnTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "addBorderTop" && prop !== "adjustPadding",
})<{ addBorderTop?: boolean; adjustPadding?: boolean }>(({ addBorderTop = false, adjustPadding = false ,theme}) => ({
  minWidth: "224px",
  position: "relative",
  border: "none !important",
  padding: adjustPadding ? "0px 8px !important" : "inherit",
  borderRight: `1px solid ${C_OUTLINE_VARIANT} !important`,
  borderLeft: `1px solid ${C_OUTLINE_VARIANT} !important`,
  borderTop: addBorderTop ? `1px solid ${C_OUTLINE_VARIANT} !important` : "none",
  "&:empty": {
    border: "none !important",
  },
  [theme.breakpoints.down("desktop-m")]: {
    minWidth: "175.75px",
  },
  [theme.breakpoints.down("desktop-s")]: {
    minWidth: "151px",
  },
}));

//TODO : we're blocked by table.less and it's breaking so added !important for border style
export const StyledRowTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isFirstRow" && prop !== "isLastRow",
})<{ isFirstRow: boolean; isLastRow: boolean }>(({ isFirstRow, isLastRow }) => ({
  borderLeft: `1px solid ${C_OUTLINE_VARIANT} !important`,
  borderRight: `1px solid ${C_OUTLINE_VARIANT} !important`,
  borderTop: isFirstRow ? `1px solid ${C_OUTLINE_VARIANT} !important` : "none",
  borderBottom: isLastRow ? `1px solid ${C_OUTLINE_VARIANT} !important` : "none",
}));

export const StyledPinIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "isPinned",
})<{ isPinned: boolean }>(({ isPinned }) => ({
  position: "absolute",
  top: 0,
  right: 0,
  color: isPinned ? C_PRIMARY : C_ON_SURFACE_VARIANT,
}));

export const ColumnImage = styled("img")(({ theme }) => ({
  width: "120px",
  height: "120px",
  objectFit: "cover",
  marginTop: "16px",
  marginBottom: "8px",
  [theme.breakpoints.down("desktop-s")]: {
    display: "none",
  },
}));

export const HeaderCellTitleWithTooltip = styled(PopperTooltip)({
  ...getFontStyle(FontSize.TitleMedium),
  fontWeight: "bold",
  textWrap: "wrap",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
  overflow: "hidden",
  textOverflow: "ellipsis",
  width: "calc(100% - 20px)",
});

export const ValueTextWithTooltip = styled(PopperTooltip)({
  ...getFontStyle(FontSize.BodyMedium),
  textWrap: "wrap",
  display: "-webkit-box",
  WebkitBoxOrient: "vertical",
  WebkitLineClamp: 2,
  overflow: "hidden",
  textOverflow: "ellipsis",
});
